import { render, staticRenderFns, recyclableRender, components } from "./exam-page.vue?vue&type=template&id=f98e4d70&scoped=true&"
var renderjs
import script from "./exam-page.vue?vue&type=script&lang=js&"
export * from "./exam-page.vue?vue&type=script&lang=js&"
import style0 from "./exam-page.vue?vue&type=style&index=0&id=f98e4d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98e4d70",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/exam-page.vue"
export default component.exports